import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var QueueService = /*#__PURE__*/function () {
  function QueueService() {
    _classCallCheck(this, QueueService);
    this.items = [];
  }
  return _createClass(QueueService, [{
    key: "enqueue",
    value: function enqueue(item) {
      this.items.push(item);
    }
  }, {
    key: "enqueueWithPromise",
    value: function enqueueWithPromise(item, resolver) {
      this.items.push({
        item: item,
        resolver: resolver
      });
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      if (this.isEmpty()) {
        return null;
      }
      return this.items.shift();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.items.length === 0;
    }
  }, {
    key: "hasItemWithCondition",
    value: function hasItemWithCondition(condition) {
      return this.items.some(condition);
    }
  }]);
}();
export default QueueService;